<template>
    <div>
        <div class="turnTable">
            <LuckyWheel
                class="turn"
                ref="myLucky"
                :default-config="defaultConfig"
                :blocks="blocks"
                :width="realWidth"
                :height="realWidth"
                :prizes="prizes"
                @end="endCallback"
            />
            <img
                src="@/assets/Share-two.png"
                class="shareBut"
                @click="friendsHelp"
            />
            <!-- <div class="prizeTips">最高可获得iPhone16手机一部！</div> -->
            <div class="activityDate">
                活动时间:{{
                    (activityAlldata.startTime || "")
                        .split(" ")[0]
                        .replace(/-/g, ".")
                }}
                - {{
                    (activityAlldata.endTime || "")
                        .split(" ")[0]
                        .replace(/-/g, ".")
                }}
            </div>
            <!-- 弹幕 -->
            <div id="container"></div>
            <img class="lightClass" src="../assets/turnLight.png" alt="" />
            <img
                class="goClass"
                src="../assets/turnGo.png"
                alt=""
                @click="startCallback"
            />
            <div class="turnNumber">
                <img
                    src="@/assets/blankGrid.png"
                    alt=""
                    style="width: 160px; height: 34px"
                />
                <div class="countClass">
                    抽奖次数<span
                        style="margin-right: 20px; margin-left: 20px"
                        >{{ count }}</span
                    >次
                </div>
            </div>
            <div class="turnTableBtn">
                <img
                    src="@/assets/activityRules.png"
                    alt=""
                    srcset=""
                    style="width: 76px; height: 76px"
                    @click="activityRules"
                />
                <img
                    src="@/assets/prizeDraw.png"
                    alt=""
                    srcset=""
                    style="width: 180px; height: 43px"
                    @click="startCallback"
                />
                <img
                    src="@/assets/myPrize.png"
                    alt=""
                    srcset=""
                    @click="myPrize(1)"
                />
            </div>
            <van-popup
                round
                v-model="loginShow"
                :style="{ backgroundColor: 'transparent' }"
            >
                <div style="height: calc(100vh - 10vh)">
                    <div class="loginBackground" v-if="status === 1">
                        <div
                            class="form-container"
                            style="
                                position: absolute;
                                top: 39%;
                                left: 0;
                                right: 0;
                                margin: 0 auto;
                                width: 270px;
                                text-align: center;
                            "
                        >
                            <van-field
                                v-model="form.username"
                                placeholder="请输入手机号"
                                type="tel"
                            ></van-field>
                            <van-field
                                v-model="code"
                                placeholder="请输入图形验证码"
                            >
                                <template #extra>
                                    <img :src="imgUrl" @click="getCode" />
                                </template>
                            </van-field>
                            <van-field
                                v-model="form.checkCode"
                                :maxlength="4"
                                placeholder="请输入短信验证码"
                            >
                                <template #extra>
                                    <span
                                        class="sendBtn"
                                        @click="sendMsg"
                                        v-text="
                                            (!state.smsSendBtn &&
                                                '获取验证码') ||
                                            state.time + ' s'
                                        "
                                        >发送验证码</span
                                    >
                                </template>
                            </van-field>
                        </div>
                        <van-button
                            @click="handleRegis"
                            round
                            class="loginButton"
                            >注册/登录</van-button
                        >
                        <div
                            class="closeImg"
                            @click="closeLoginShow"
                            style="
                                margin: 0 auto;
                                left: 0;
                                right: 0;
                                text-align: center;
                                bottom: -12%;
                            "
                        >
                            <img
                                style="height: 30px"
                                src="../assets/Close.png"
                            />
                        </div>
                    </div>
                    <div v-if="status === 2" style="height: calc(100vh - 10vh)">
                        <div class="winningLottery">
                            <div
                                style="
                                    color: #87151e;
                                    position: absolute;
                                    top: 25%;
                                    left: 23%;
                                    font-size: 24px;
                                "
                            >
                                窝窝投 | 幸运大转盘
                            </div>
                            <div class="form-container">
                                <div class="thankFontClassOne" style="top: 36%">
                                    <img
                                        src="@/assets/logo_wowotown.png"
                                        alt=""
                                        srcset=""
                                    />
                                    <span
                                        style="
                                            display: block;
                                            font-size: 18px;
                                            font-weight: 500;
                                            margin-top: 5px;
                                        "
                                        >没有抽奖机会啦~</span
                                    >
                                </div>
                                <van-button
                                    v-if="isApp || clientType === 'wxmini'"
                                    @click="
                                        String(
                                            activityAlldata.turntableMode || '10'
                                        ).indexOf('20') !== -1
                                            ? closeLoginShow()
                                            : sendMessage()
                                    "
                                    round
                                    class="downloadButton"
                                    style="top: 82%; left: 7%"
                                    >{{
                                        String(
                                            activityAlldata.turntableMode || '10'
                                        ).indexOf('20') !== -1
                                            ? "去做任务｜获取更多机会"
                                            : "邀请好友｜获取更多机会"
                                    }}
                                </van-button>
                                <van-button
                                    v-else
                                    @click="downloadApp"
                                    round
                                    class="downloadButton"
                                    style="top: 82%; left: 7%"
                                    >下载APP｜获取更多机会
                                </van-button>
                            </div>
                        </div>
                        <div
                            class="closeImg"
                            @click="closeLoginShow"
                            style="margin: 28% 48%"
                        >
                            <img
                                style="height: 30px"
                                src="../assets/Close.png"
                            />
                        </div>
                    </div>
                    <div v-if="status === 3" style="height: calc(100vh - 10vh)">
                        <div class="notWinningLottery">
                            <div
                                style="
                                    color: #87151e;
                                    position: absolute;
                                    top: 32%;
                                    left: 24%;
                                    font-size: 24px;
                                "
                            >
                                窝窝投 | 幸运大转盘
                            </div>
                            <div class="form-container">
                                <div class="thankFontClassOne">
                                    <img
                                        src="@/assets/logo_wowotown.png"
                                        alt=""
                                        srcset=""
                                    />
                                    <span
                                        style="
                                            display: block;
                                            font-size: 18px;
                                            font-weight: 500;
                                        "
                                        >好可惜, 差一点就中奖了~</span
                                    >
                                </div>

                                <van-button
                                    v-if="isApp || clientType === 'wxmini'"
                                    @click="drawAgain"
                                    round
                                    class="appButton"
                                    style="top: 84%; left: 13%"
                                    >再抽一次
                                </van-button>
                                <van-button
                                    v-if="isApp || clientType === 'wxmini'"
                                    @click="myPrize(1)"
                                    round
                                    class="appButton"
                                    style="top: 84%; left: 60%"
                                    >我的奖品</van-button
                                >
                                <van-button
                                    v-else
                                    @click="downloadApp"
                                    round
                                    class="downloadButton"
                                    style="top: 84%; left: 5%"
                                    >下载APP｜获取更多机会
                                </van-button>
                            </div>
                            <div
                                class="closeImg"
                                @click="closeLoginShow"
                                style="margin: -15% 48%; bottom: 0"
                            >
                                <img
                                    style="height: 30px"
                                    src="../assets/Close.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="status === 4"
                        class="loginBack"
                        style="top: -38px"
                    >
                        <div class="form-container">
                            <div class="getFontClassOne">恭喜中奖啦!</div>
                            <div class="getFontClassTwo">
                                <!-- <div class="shop-boxTwo"> -->
                                <div class="img-box">
                                    <img
                                        v-if="recordType === 70"
                                        style="
                                            border-radius: 16px;
                                            object-fit: contain;
                                            width: 118px;
                                            height: 118px;
                                        "
                                        src="../assets//amountGroup.png"
                                        width="118"
                                        height="118"
                                    />
                                    <div
                                        v-else-if="recordType === 100 && !recordImages"
                                        style="
                                            width: 118px;
                                            height: 118px;
                                            border-radius: 16px;
                                            background: #f5f5f5;
                                            color: #999;
                                            font-size: 24px;
                                            font-weight: 700;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                        "
                                    >
                                        CDK
                                    </div>
                                    <img
                                        v-else
                                        style="
                                            border-radius: 16px;
                                            object-fit: contain;
                                            width: 118px;
                                            height: 118px;
                                        "
                                        :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${recordImages}`"
                                        width="118"
                                        height="118"
                                    />
                                </div>
                                <div class="shop-info-box">
                                    <p style="margin: 5px 0; font-size: 20px">
                                        {{ recordName }}
                                    </p>
                                    <p
                                        v-if="recordType === 70"
                                        style="
                                            color: #4e5969;
                                            font-size: 20px;
                                            margin-top: 5px;
                                        "
                                    >
                                        {{ recordAmount }}元现金
                                    </p>
                                    <p
                                        v-else-if="recordType !== 100"
                                        style="
                                            color: #4e5969;
                                            font-size: 20px;
                                            margin-top: 5px;
                                        "
                                    >
                                        价值：{{ recordAmount }}元
                                    </p>
                                    <p
                                        v-if="recordType === 70"
                                        class="turnPrize"
                                        style="margin-top: -10px"
                                    >
                                        兑奖完成后，请到APP“个人中心-钱包管理”提现
                                    </p>
                                    <p
                                        v-else-if="recordType === 100"
                                        class="turnPrize"
                                        style="margin-top: -10px"
                                    >
                                        兑换码已发放，可在“我的奖品”中查看，点击“去兑换”自动复制兑换码。
                                    </p>
                                    <p
                                        v-else
                                        class="turnPrize"
                                        style="margin-top: -10px"
                                    >
                                        获得的奖品可以在我的奖品中查看，实物奖品记得填写收货地址哦。
                                    </p>
                                </div>
                                <!-- v-if="isApp" -->
                                <van-button
                                    v-if="isApp || clientType === 'wxmini'"
                                    @click="drawAgain"
                                    round
                                    class="appButton"
                                    >再抽一次
                                </van-button>
                                <van-button
                                    v-if="isApp || clientType === 'wxmini'"
                                    style="left: 60%"
                                    @click="myPrize(1)"
                                    round
                                    class="appButton"
                                    >我的奖品</van-button
                                >
                                <van-button
                                    v-else
                                    @click="downloadApp"
                                    round
                                    class="downloadButton"
                                    >下载APP｜领取奖励</van-button
                                >
                                <div
                                    class="closeImg"
                                    @click="closeLoginShow"
                                    style="top: 0; left: 40%"
                                >
                                    <img
                                        style="height: 30px"
                                        src="../assets/Close.png"
                                    />
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                    <div v-if="status === 0" style="height: calc(100vh - 10vh)">
                        <div class="rulesPop">
                            <!-- <img src="@/assets/ruleExplanation.png" alt=""
                            style="height:440px;width:320px;position: relative;top:15%;"> -->
                            <div
                                style="
                                    position: absolute;
                                    top: 17%;
                                    left: 0;
                                    right: 0;
                                    text-align: center;
                                    height: 66%;
                                "
                            >
                                <div style="font-size: 28px; color: #87151e">
                                    活动规则
                                </div>
                                <div
                                    style="
                                        height: 89%;
                                        width: 90%;
                                        margin: 10px;
                                        text-align: start;
                                        color: #4e5969;
                                        font-size: 16px;
                                        word-wrap: break-word;
                                        overflow-y: auto;
                                        white-space: pre-wrap;
                                    "
                                    v-html="description"
                                ></div>

                                <van-button
                                    @click="closeLoginShow"
                                    class="turnCloseBtn"
                                    >我知道了</van-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
            <van-popup
                round
                v-model="myPrizeShow"
                :style="{ backgroundColor: 'transparent' }"
            >
                <!-- style="height:600px;" -->
                <div
                    v-if="recordStatus === 1"
                    style="height: calc(100vh - 10vh)"
                >
                    <div class="myAwaryClass">
                        <div class="myRecordClass">
                            <span
                                style="
                                    margin: 0px 15px;
                                    color: #87151e;
                                    font-size: 32px;
                                "
                                >我的奖品</span
                            >
                        </div>
                        <div
                            style="
                                width: 85vw;
                                height: 63%;
                                position: absolute;
                                top: 34%;
                                border-radius: 5%;
                                right: 0;
                                left: 0;
                                margin: 0 auto;
                                overflow: hidden;
                            "
                        >
                            <div class="list-wrapper">
                                <div
                                    id="apply1"
                                    v-for="(item, index) in recordList"
                                    :key="index"
                                >
                                    <!-- 优惠券 -->
                                    <div
                                        v-if="item.activityProductType === 30"
                                        class="shop-box"
                                    >
                                        <div class="img-box">
                                            <img
                                                style="
                                                    border-radius: 10px;
                                                    object-fit: cover;
                                                    object-fit: cover;
                                                    width: 78px;
                                                    height: 78px;
                                                "
                                                :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.activityProductImg}`"
                                            />
                                            <div class="shop-info-box">
                                                <div
                                                    style="
                                                        margin-left: 5px;
                                                        width: 70%;
                                                    "
                                                >
                                                    <p class="shop-name">
                                                        {{
                                                            item.activityProductName
                                                        }}
                                                    </p>
                                                    <p style="font-size: 10px">
                                                        有效期：
                                                        <span
                                                            v-if="
                                                                item.longTermStatus ===
                                                                10
                                                            "
                                                            >长期</span
                                                        >
                                                        <span
                                                            v-if="
                                                                item.longTermStatus ===
                                                                20
                                                            "
                                                            >{{
                                                                item.startTime.slice(
                                                                    0,
                                                                    -9
                                                                )
                                                            }}-{{
                                                                item.endTime.slice(
                                                                    0,
                                                                    -9
                                                                )
                                                            }}</span
                                                        >
                                                    </p>
                                                    <p style="font-size: 10px">
                                                        使用说明：
                                                        <span
                                                            @click="
                                                                moreFont(item)
                                                            "
                                                            >{{
                                                                item.instructions
                                                                    | ellipsis
                                                            }}</span
                                                        >
                                                    </p>
                                                </div>
                                                <van-dialog
                                                    :width="280"
                                                    :overlay="false"
                                                    @confirm="closeIn(item)"
                                                    style="font-size: 10px"
                                                    v-model="item.showPopover"
                                                >
                                                    <template
                                                        slot="title"
                                                        style="font-size: 20px"
                                                        >使用说明</template
                                                    >
                                                    <template
                                                        slot="default"
                                                        style="
                                                            margin-left: 5%;
                                                            color: #999999;
                                                            background-color: #febe8d;
                                                            font-family: PingFangSC-Regular;
                                                            font-size: 16px;
                                                        "
                                                    >
                                                        {{ item.instructions }}
                                                    </template>
                                                </van-dialog>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        20
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="duihuan(item)"
                                                    >兑换
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        10
                                                    "
                                                    round
                                                    disabled
                                                    class="switch-shop-btn"
                                                    >已使用
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        30
                                                    "
                                                    round
                                                    disabled
                                                    class="switch-shop-btn"
                                                    >已过期
                                                </van-button>
                                            </div>
                                        </div>
                                        <div
                                            v-if="item.isCode"
                                            style="
                                                text-align: center;
                                                position: relative;
                                            "
                                        >
                                            <!-- :text="`https://apph5web.wowotown.com/CopupCompanyLogin?id=${item.id}`" -->
                                            <!-- :text="`https://apph5web.loool-me.com/writeOff?id=${item.id}`" -->
                                            <div
                                                style="margin-top: 5px"
                                                v-if="
                                                    item.couponPlatForm === 90
                                                "
                                            >
                                                {{ item.id }}
                                            </div>
                                            <div style="margin-top: 5px" v-else>
                                                {{ item.couponCode }}
                                            </div>
                                            <vue-qr
                                                v-if="
                                                    item.couponPlatForm === 90
                                                "
                                                :text="`https://apph5web.wowotown.com/writeOff?id=${item.id}`"
                                                :size="200"
                                            ></vue-qr>
                                            <vue-qr
                                                v-else
                                                :text="`${item.couponCode}`"
                                                :size="200"
                                            ></vue-qr>
                                            <!-- 优惠券所属平台 -->
                                            <div class="SystemCoupons">
                                                <img
                                                    v-if="
                                                        item.couponPlatForm ===
                                                        10
                                                    "
                                                    src="../assets/credit/icon-dzdp.png"
                                                    style="
                                                        width: 20px;
                                                        height: 20px;
                                                    "
                                                />
                                                <img
                                                    v-if="
                                                        item.couponPlatForm ===
                                                        20
                                                    "
                                                    src="../assets/credit/icon-dy.png"
                                                    style="
                                                        width: 20px;
                                                        height: 20px;
                                                    "
                                                />
                                                <img
                                                    v-if="
                                                        item.couponPlatForm ===
                                                        30
                                                    "
                                                    src="../assets/credit/icon-dzdp.png"
                                                    style="
                                                        width: 20px;
                                                        height: 20px;
                                                    "
                                                />
                                                <img
                                                    v-if="
                                                        item.couponPlatForm ===
                                                        90
                                                    "
                                                    src="../assets/ic_logo.png"
                                                    style="
                                                        width: 20px;
                                                        height: 20px;
                                                    "
                                                />
                                                <span style="font-size: 13px">{{
                                                    item.couponPlatForm === 10
                                                        ? "大众点评"
                                                        : item.couponPlatForm ===
                                                          20
                                                        ? "抖音"
                                                        : item.couponPlatForm ===
                                                          30
                                                        ? "美团"
                                                        : item.couponPlatForm ===
                                                          90
                                                        ? "窝窝投"
                                                        : ""
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <van-dialog
                                        :overlay="false"
                                        v-model="infoShow"
                                        @confirm="downloadApp"
                                        :theme="'round-button'"
                                        :confirm-button-text="'下载APP｜领取奖励'"
                                        :confirm-button-color="'#FEBE8D'"
                                    >
                                        <template
                                            slot="title"
                                            style="
                                                color: #ffffff;
                                                background-color: #febe8d;
                                                font-family: PingFangSC-Regular;
                                                font-size: 16px;
                                            "
                                        >
                                            提示
                                        </template>
                                        <div
                                            style="
                                                text-align: center;
                                                color: #000000;
                                                font-family: PingFangSC-Regular;
                                                font-size: 16px;
                                            "
                                        >
                                            请在APP兑换奖励
                                        </div>
                                        <div
                                            style="
                                                position: relative;
                                                margin-left: 90%;
                                                margin-top: -20%;
                                            "
                                            @click="infoShow = false"
                                        >
                                            <img
                                                style="height: 20px"
                                                src="../assets/turnClose.png"
                                            />
                                        </div>
                                    </van-dialog>
                                    <!-- 实物奖励 -->
                                    <div
                                        v-if="item.activityProductType === 60"
                                        class="shop-box"
                                    >
                                        <div class="img-box">
                                            <img
                                                style="
                                                    border-radius: 5px;
                                                    object-fit: cover;
                                                    width: 78px;
                                                    height: 78px;
                                                "
                                                :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.activityProductImg}`"
                                            />
                                            <span
                                                v-if="item.deliveryStatus === 1"
                                                class="Shipped"
                                                >已发货</span
                                            >
                                            <div class="shop-info-box">
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: column;
                                                        width: 70%;
                                                    "
                                                >
                                                    <p class="shop-name">
                                                        {{
                                                            item.activityProductName
                                                        }}
                                                    </p>
                                                    <p
                                                        style="
                                                            font-size: 16px;
                                                            color: #4e5969;
                                                            margin-top: 10px;
                                                        "
                                                    >
                                                        价值：{{
                                                            item.productAmount
                                                        }}元
                                                    </p>
                                                </div>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                            20 &&
                                                        !item.name &&
                                                        !item.userAddressId
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="duihuan(item)"
                                                    >立即兑奖</van-button
                                                >
                                                <van-button
                                                    v-if="
                                                        item.name &&
                                                        item.userAddressId &&
                                                        item.deliveryStatus ===
                                                            0
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="duihuan(item)"
                                                    >修改地址
                                                </van-button>
                                                <!-- <van-button v-if="
                                                    item.productStatus ===
                                                    10 && item.deliveryExpressName && item.deliveryExpressId
                                                " round disabled class="switch-shop-btn">已使用
                                                </van-button> -->
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        30
                                                    "
                                                    round
                                                    disabled
                                                    class="switch-shop-btn"
                                                    >已过期
                                                </van-button>
                                                <span
                                                    v-if="
                                                        item.name &&
                                                        item.userAddressId &&
                                                        item.phone &&
                                                        item.deliveryStatus ===
                                                            1
                                                    "
                                                    class="switch-shop-check"
                                                    @click="checkDelivery(item)"
                                                    >查看快递信息</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                item.isShow &&
                                                item.id === duihuanData.id
                                            "
                                        >
                                            <div v-if="item.isArea">
                                                <van-address-edit
                                                    :address-info="{
                                                        name: addAddress.name,
                                                        tel: addAddress.phone,
                                                        addressDetail:
                                                            addAddress.address,
                                                        areaCode:
                                                            addAddress.areaCode,
                                                    }"
                                                    :save-button-text="'确认'"
                                                    :area-list="areaList"
                                                    :area-columns-placeholder="[
                                                        '请选择',
                                                        '请选择',
                                                        '请选择',
                                                    ]"
                                                    @save="onSave"
                                                >
                                                    <div
                                                        style="
                                                            font-size: 12px;
                                                            margin: 5px 0px 0
                                                                3px;
                                                            color: #969799;
                                                        "
                                                    >
                                                        奖品的寄送邮费需用户自行承担，默认圆通/邮政EMS
                                                    </div>
                                                </van-address-edit>
                                            </div>
                                            <div
                                                v-if="item.isAreaList"
                                                style="margin-left: 5%"
                                            >
                                                <van-row
                                                    style="
                                                        font-size: 14px;
                                                        font-weight: bold;
                                                    "
                                                    >{{ item.name }}
                                                </van-row>
                                                <van-row
                                                    style="
                                                        font-size: 14px;
                                                        color: #6f6f6f;
                                                    "
                                                >
                                                    {{ item.province }}
                                                    {{ item.city }}
                                                    {{ item.district }}
                                                </van-row>
                                                <van-row
                                                    style="
                                                        font-size: 14px;
                                                        color: #6f6f6f;
                                                    "
                                                >
                                                    详细地址：{{ item.address }}
                                                </van-row>
                                                <div
                                                    style="
                                                        display: flex;
                                                        justify-content: space-around;
                                                    "
                                                >
                                                    <van-button
                                                        class="addClass"
                                                        round
                                                        @click="
                                                            updateAddress(item)
                                                        "
                                                    >
                                                        修改
                                                    </van-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 现金奖励 70-->
                                    <div
                                        v-if="item.activityProductType === 70"
                                        class="shop-box"
                                    >
                                        <div class="img-box">
                                            <img
                                                style="
                                                    border-radius: 5px;
                                                    object-fit: cover;
                                                    width: 78px;
                                                    height: 78px;
                                                "
                                                src="../assets/amountGroup.png"
                                            />
                                            <div class="shop-info-box">
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: column;
                                                        width: 70%;
                                                    "
                                                >
                                                    <p class="shop-name">
                                                        现金
                                                        {{
                                                            item.activityProductAmount /
                                                            100
                                                        }}
                                                        元
                                                    </p>
                                                    <span
                                                        style="font-size: 10px"
                                                    >
                                                        兑奖后请到“个人中心-钱包管理”提现
                                                    </span>
                                                </div>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        20
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="duihuanAmount(item)"
                                                    >立即兑奖
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        10
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="goWithdrawal(item)"
                                                    >提现
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        30
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    >已过期
                                                </van-button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 兑换码奖励 100（普通/gaga等CDK）-->
                                    <div
                                        v-if="item.activityProductType === 100"
                                        class="shop-box"
                                    >
                                        <div class="img-box">
                                            <img
                                                v-if="item.activityProductImg"
                                                style="
                                                    border-radius: 5px;
                                                    object-fit: cover;
                                                    width: 78px;
                                                    height: 78px;
                                                "
                                                :src="
                                                    picUrl +
                                                    item.activityProductImg
                                                "
                                            />
                                            <div
                                                v-else
                                                style="
                                                    width: 78px;
                                                    height: 78px;
                                                    border-radius: 5px;
                                                    background: #f5f5f5;
                                                    color: #999;
                                                    font-size: 16px;
                                                    font-weight: 700;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                "
                                            >
                                                CDK
                                            </div>
                                            <div class="shop-info-box">
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: column;
                                                        width: 70%;
                                                    "
                                                >
                                                    <p class="shop-name">
                                                        {{
                                                            item.activityProductName
                                                        }}
                                                    </p>
                                                    <p
                                                        style="
                                                            font-size: 13px;
                                                            color: #4e5969;
                                                            margin-top: 5px;
                                                        "
                                                    >
                                                        兑换码：<span
                                                            style="
                                                                color: #f5410e;
                                                                font-weight: 600;
                                                            "
                                                            >{{
                                                                item.couponCode
                                                            }}</span
                                                        >
                                                    </p>
                                                    <span style="font-size: 10px">
                                                        {{
                                                            item.productStatus ===
                                                                20 &&
                                                            Number(
                                                                item.cdkType
                                                            ) ===
                                                                20
                                                                ? '点击"去兑换"前往gaga小程序兑换'
                                                                : '点击"复制"复制兑换码，前往对应平台粘贴兑换'
                                                        }}
                                                    </span>
                                                </div>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                            20 &&
                                                        Number(item.cdkType) ===
                                                            20
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="exchangeGaga(item)"
                                                    >去兑换
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                            20 &&
                                                        Number(item.cdkType) !==
                                                            20
                                                    "
                                                    round
                                                    class="switch-shop-btn"
                                                    @click="copyCdk(item)"
                                                    >复制
                                                </van-button>
                                                <van-button
                                                    v-if="
                                                        item.productStatus ===
                                                        30
                                                    "
                                                    round
                                                    disabled
                                                    class="switch-shop-btn"
                                                    >已过期
                                                </van-button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 提示未实名认证 -->
                                    <!-- <van-dialog :overlay="false" v-model="realNameShow" @confirm="goRealName"
                                        :theme="'round-button'" :confirm-button-text="'去实名'"
                                        :confirm-button-color="'#FEBE8D'">
                                        <template slot="title" style="
                                                color: #ffffff;
                                                background-color: #febe8d;
                                                font-family: PingFangSC-Regular;
                                                font-size: 16px;
                                            ">
                                            请先完成实名认证
                                        </template>
                                        <div style="
                                                text-align: center;
                                                color: #000000;
                                                font-family: PingFangSC-Regular;
                                                font-size: 16px;
                                            ">
                                            请先完成实名认证
                                        </div>
                                        <div style="
                                                position: relative;
                                                margin-left: 90%;
                                                margin-top: -20%;
                                            " @click="realNameShow = false">
                                            <img style="height: 20px" src="../assets/turnClose.png" />
                                        </div>
                                    </van-dialog> -->
                                    <!-- end -->
                                </div>
                            </div>
                        </div>
                        <div
                            class="closeImg"
                            @click="closeMyPrizeShow"
                            style="margin: -25% 48%; bottom: 8%"
                        >
                            <img
                                style="height: 30px"
                                src="../assets/Close.png"
                            />
                        </div>
                    </div>
                </div>
            </van-popup>
            <!-- 实物查看快递地址 -->
            <van-dialog
                style="
                    background: linear-gradient(
                        180deg,
                        #ffcddd 0%,
                        #fefae3 100%
                    );
                "
                :overlay="true"
                v-model="addressShow"
                :title="checkDeliveryData.activityProductName"
                :show-confirm-button="false"
                :show-cancel-button="false"
            >
                <span
                    @click="addressShow = false"
                    style="
                        position: absolute;
                        top: 10px;
                        right: 25px;
                        font-size: 18px;
                    "
                    >X</span
                >
                <div class="productShipped">奖品已发货</div>
                <div
                    style="
                        background-color: #ffffff;
                        border-radius: 14px;
                        padding: 10px;
                        margin-bottom: 15px;
                    "
                >
                    <div class="addressList">
                        <img
                            :src="
                                getExpressLogo(
                                    checkDeliveryData.deliveryExpressId
                                )
                            "
                            style="width: 22px; height: 22px; margin-right: 5px"
                        />
                        {{ checkDeliveryData.deliveryExpressName }}
                        {{ checkDeliveryData.deliveryExpressNo }}
                        <div
                            class="copyBtn"
                            @click="
                                copyText(checkDeliveryData.deliveryExpressNo)
                            "
                        >
                            复制
                        </div>
                    </div>
                    <div style="font-size: 14px">
                        <van-icon name="location" />
                        送至 {{ checkDeliveryData.city }}
                        {{ checkDeliveryData.province }}
                        {{ checkDeliveryData.district }}
                        {{ checkDeliveryData.address }}
                    </div>
                    <div style="margin: 0 0 10px 18px; font-size: 14px">
                        {{ checkDeliveryData.name }}
                        {{ checkDeliveryData.userNickPhone }}
                    </div>
                </div>
            </van-dialog>

            <!-- end -->
            <!-- 1.0.3start（拉新模式才显示邀请助力区块；任务模式由完成任务获得次数） -->
            <div class="helpList" v-if="String(activityAlldata.turntableMode || '10').indexOf('10') !== -1">
                <div class="helpListTitle">
                    每
                    <span style="color: #ff3b58"
                        >{{
                            (activityAlldata.activityParticipationRules &&
                            activityAlldata.activityParticipationRules[0]
                                ? activityAlldata.activityParticipationRules[0]
                                      .quoteCount
                                : 1)
                        }}个</span
                    >好友完成注册，就能获得<span style="color: #ff3b58"
                        >1次</span
                    >抽奖机会
                </div>
                <div class="helpListContent">
                    <div
                        style="
                            width: 100%;
                            display: flex;
                            justify-content: space-around;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-around;
                                width: 100%;
                            "
                            v-if="inviteList.length === 0"
                        >
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    text-align: center;
                                "
                                v-for="item in (activityAlldata.activityParticipationRules && activityAlldata.activityParticipationRules[0] ? activityAlldata.activityParticipationRules[0].quoteCount : 1)"
                                :key="item"
                            >
                                <span class="helpListImg">+</span>
                                <span style="font-size: 12px; color: #999999"
                                    >待助力</span
                                >
                            </div>
                        </div>
                        <!-- start -->
                        <van-row
                            v-else
                            class="list-wrapper-ooooo"
                            style="width: 100%"
                        >
                            <div class="shop-boxx">
                                <van-col
                                    style="
                                        margin-right: 10px;
                                        text-align: center;
                                    "
                                    v-for="(item, index) in displayList"
                                    :key="index"
                                >
                                    <template v-if="item.id">
                                        <img
                                            class="itemAvatar"
                                            :src="picUrl + item.avatarUrl"
                                            alt=""
                                            srcset=""
                                        />
                                        <van-row>
                                            <span style="font-size: 12px">{{
                                                item.phone.substring(8)
                                            }}</span>
                                        </van-row>
                                    </template>
                                    <div
                                        v-else
                                        style="
                                            display: flex;
                                            flex-direction: column;
                                        "
                                    >
                                        <span class="helpListImg">+</span>
                                        <span
                                            style="
                                                font-size: 12px;
                                                color: #999999;
                                            "
                                            >待助力</span
                                        >
                                    </div>
                                </van-col>
                            </div>
                        </van-row>
                        <!-- end -->
                    </div>
                    <div style="position: relative; margin-top: 22px">
                        <img
                            src="@/assets/InviteFriends.png"
                            alt=""
                            style="width: 105px; height: 32px"
                            @click="friendsHelp"
                        />
                        <img
                            src="@/assets/LotteryTips.png"
                            alt=""
                            style="position: absolute; left: 48%; top: -17px"
                        />
                    </div>
                </div>
            </div>
            <!-- 助力列表 -->
            <div class="helpListDetail" style="margin-top: 20px" v-if="String(activityAlldata.turntableMode || '10').indexOf('10') !== -1">
                <div class="helpListTitle">
                    <span style="color: #ff3b58">{{ inviteList.length }}位</span
                    >好友已成功助力
                </div>
                <div class="itemContent">
                    <div
                        class="itemList"
                        v-for="(item, index) in inviteList"
                        :key="index"
                    >
                        <div style="display: flex; align-items: center">
                            <img
                                :src="picUrl + item.avatarUrl"
                                alt=""
                                srcset=""
                                style="
                                    width: 32px;
                                    height: 32px;
                                    border-radius: 50%;
                                "
                            />
                            <div style="margin-left: 10px">
                                {{ item.phone }}
                            </div>
                        </div>

                        <div>{{ item.gmtCreate }}</div>
                    </div>
                    <div
                        v-if="inviteList.length === 0"
                        style="
                            text-align: center;
                            margin-top: 15%;
                            color: #a54b06;
                            font-size: 16px;
                        "
                    >
                        目前还没有好友助力...
                    </div>
                </div>
            </div>
            <!-- end -->
            <van-dialog v-model="activityInfo" @confirm="activityInfo = false">
                <div
                    slot="title"
                    v-if="activityState === 1"
                    style="
                        text-align: center;
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                    "
                >
                    活动未开始
                </div>
                <div
                    slot="title"
                    v-if="activityState === 2"
                    style="
                        text-align: center;
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                    "
                >
                    活动已结束
                </div>
                <div
                    slot="title"
                    v-if="activityState === 3"
                    style="
                        text-align: center;
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                    "
                >
                    活动已下架
                </div>
            </van-dialog>
        </div>
    </div>
</template>
<script src="https://cdn.jsdelivr.net/combine/npm/@vue/composition-api@1.2.4,npm/vue-demi@0.11.4/lib/index.iife.min.js,npm/@lucky-canvas/vue@0.1.8"></script>
<script>
import {
    fetchCode,
    fetchLogin,
    getActivityDetail,
    getActivityList,
    getRecordList,
    getSmsCaptcha,
    luckDraw,
    getActivityRecord,
    getInviteList,
    addAddress,
    getUserInfo,
    redeemNow,
} from "@/services/common";
import { Notify } from "vant";
import Cookies from "js-cookie";
import VueBarcode from "vue-barcode";
import vueQr from "vue-qr";
import { areaList } from "@vant/area-data";
import easyDanmaku from "easy-danmaku-js"; //弹幕插件
var _ = require("lodash");

export default {
    name: "Turntable",
    components: {
        barcode: VueBarcode,
        vueQr,
    },
    data() {
        return {
            duihuanData: {},
            redeemNowList: {},
            isAreaList: false,
            inviteListFetched: false,
            isArea: false,
            defaultConfig: { gutter: "5px" },
            blocks: [{ padding: "1px", background: "#F5410E" }],
            winningIndex: -1,
            addAddress: {
                name: "",
                phone: "",
                address: "",
                addressString: "",
                province: "",
                city: "",
                district: "",
                areaCode: "",
            },
            isShow: false,
            picUrl: "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/",
            prizes: [],
            count: 0,
            description: "",
            winningList: [],
            activityId: "",
            activityProduct: [],
            activityAlldata: {
                startTime: '',
                endTime: '',
                turntableMode: '10',
                // 默认带一个规则项，避免模板/计算属性直接访问 [0] 崩溃（任务模式 rules 为空）
                activityParticipationRules: [{ quoteCount: 1 }],
            },
            loginShow: false,
            form: {
                username: "",
                checkCode: "",
                invitationCode: "",
                type: 0,
                registerActivityId: "",
            },
            code: "",
            imgUrl: "",
            state: {
                time: 60,
                smsSendBtn: false,
            },
            myPrizeShow: false,
            status: 0, //1没登录 2没抽奖次数 3没有中奖 4中奖啦
            isApp: false,
            clientType: "", // 端类型：''=浏览器/H5自有登录，'wxmini'=微信小程序内嵌H5
            userId: "",
            recordList: [],
            recordStatus: 0, //1是我的奖品 2是查看助力
            recordIndex: 0,
            imgSrc: "brand/logo/1498546621939417089.png",
            recordAmount: 0,
            recordType: 0,
            recordName: "",
            recordImages: "",
            inviteList: [],
            inviteListNew: [],
            list: [],
            list1: [],
            noWaitTime: true,
            showPopover: false,
            addCountList: [],
            infoShow: false,
            realNameShow: false,
            activityStatus: "",
            activityStartTime: "",
            activityEndTime: "",
            activityInfo: false,
            activityState: "",
            exchangeId: "",
            helpCount: 10,
            realWidth: 0,
            searchResult: [],
            areaCode: "",
            addressShow: false,
            checkDeliveryData: {},
            areaList,
        };
    },
    computed: {
        domStyle() {
            return "";
        },
        displayList() {
            const rules = this.activityAlldata.activityParticipationRules || [];
            const totalCount = (rules[0] || {}).quoteCount || 1;
            const result = [];
            if (this.inviteList.length > totalCount) {
                const groupCount = Math.ceil(
                    this.inviteList.length / totalCount
                );
                // 获取最后一组的起始索引
                const lastGroupStartIndex = (groupCount - 1) * totalCount;
                // 获取最后一组数据
                const lastGroup = this.inviteList.slice(
                    lastGroupStartIndex,
                    lastGroupStartIndex + totalCount
                );
                // 使用最后一组数据
                this.addCountList = lastGroup;
            } else {
                // 如果总数据量小于等于totalCount，直接使用全部数据
                this.addCountList = this.inviteList;
            }
            // 将最后一组数据添加到结果数组中
            this.addCountList.forEach((item) => {
                result.push({
                    ...item,
                    isReal: true,
                });
            });
            // 添加待助力占位
            const remainingCount = totalCount - this.addCountList.length;
            for (let i = 0; i < remainingCount; i++) {
                result.push({
                    isReal: false,
                });
            }

            return result;
        },
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        },
    },
    mounted() {
        // activityParticipationRules====quoteCount邀请几人;
        window.realNameAuth.sendAuthStatus = (status) => {
            if (this.redeemNowList.activityProductType === 70) {
                this.goredeemNow(status);
            }else{
                this.nextDuihuan(status);
            }
        };
    },
    created() {
        this.getActivityList();
        // 安卓 Chrome 拉起微信小程序失败（未安装微信）时，intent 的 browser_fallback_url 回跳本页带 noWechat=1
        if (this.$route.query.noWechat === "1") {
            this.$nextTick(() => {
                Notify({
                    type: "warning",
                    message: "未检测到微信，请先安装微信后再兑换",
                });
            });
        }
        let w = window.innerWidth;
        // 转盘占屏宽76%（原写法 w*0.76+"vw" 在非手机视口会生成超大vw值，组件无法解析导致转盘用默认尺寸显示异常）
        this.realWidth = Math.round(w * 0.76) + "px";
        let h = window.innerHeight;
        // Cookies.remove('mini-token')
        // Cookies.remove('mini-secretKey')
        // Cookies.remove('token')
        // Cookies.remove('secretKey')
        setTimeout(() => {
            this.getWinningList();
        }, 500);
        const data = this.$route.query;
        this.form.invitationCode = data.invitationCode;
        if (data.isApp) {
            this.isApp = true;
            const token =
                Cookies.get("token") || "6072838ead3247ff8775008c2f938551_app";
            const secretKey =
                Cookies.get("secretKey") || "554bf7f3d84b49a9aa6a7781956518fd";
            if (token === "") {
                Cookies.remove("mini-token");
                Cookies.remove("mini-secretKey");
            } else {
                Cookies.set("mini-token", token);
                Cookies.set("mini-secretKey", secretKey);
            }
        }
        if (data.id) {
            if (data.id.includes("app")) {
                this.isApp = true;
                this.userId = data.id;
                const id = this.userId.substring(3);
                this.getUserInfo(id);
            }
        }
        // 微信小程序内嵌 H5：小程序会在 URL 上带 from=wxmini + token/secretKey
        // 放在 isApp 判定之后（APP 分支优先），确保不影响 APP 侧逻辑
        if (!this.isApp && data.from === "wxmini") {
            this.clientType = "wxmini";
            if (data.token && data.secretKey) {
                Cookies.set("mini-token", data.token, { expires: 7 });
                Cookies.set("mini-secretKey", data.secretKey, { expires: 7 });
                // 同时写一份 token/secretKey：miniAxios 读取时 token cookie 优先级高于 mini-token，
                // 若用户此前在本 webview 登录过商城 H5，会出现“判定用 _mina、请求用 _h5”的串号
                Cookies.set("token", data.token, { expires: 7 });
                Cookies.set("secretKey", data.secretKey, { expires: 7 });
            } else {
                // 没带登录态（例如分享出去的地址已被剥掉 token）：清掉可能残留的他人凭证，
                // 以未登录身份重新走小程序登录，避免沿用上一个账号的数据
                Cookies.remove("mini-token");
                Cookies.remove("mini-secretKey");
                Cookies.remove("token");
                Cookies.remove("secretKey");
            }
        }
        if (data.registerActivityId) {
            this.form.registerActivityId = data.registerActivityId;
        }
    },
    methods: {
        async init() {
            _.forEach(this.areaList.city_list, (o, c) => {
                if (o == this.addAddress.city) {
                    let cityId = String(_.take(c, 2));
                    _.forEach(this.areaList.county_list, (i, a) => {
                        if (i == this.addAddress.district) {
                            let districtId = String(_.take(a, 2));
                            if (cityId == districtId) {
                                this.addAddress.areaCode = a;
                            }
                        }
                    });
                }
            });
        },
        // 根据快递公司名称获取对应的Logo
        getExpressLogo(deliveryExpressId) {
            const expressMap = {
                1: "SF.png",
                2: "ZTO.png",
                10: "EMS.png",
                3: "YTO.png",
                4: "shentong.png",
                5: "Yunda.png",
                6: "BestExpress.png",
                8: "EMS.png",
                9: "otherExpress.png",
                // 可以根据需要添加更多快递公司
            };
            const logoFile =
                expressMap[deliveryExpressId] || "otherExpress.png";
            return require(`@/assets/express/${logoFile}`);
        },
        copyText(text) {
            // 创建一个输入框元素
            const input = document.createElement("input");
            // 设置输入框的值为要复制的文本
            input.value = text;
            // 将输入框添加到页面
            document.body.appendChild(input);
            // 选择输入框中的文本
            input.select();
            // 对于iOS设备，设置选择范围
            input.setSelectionRange(0, input.value.length);
            // 尝试执行复制命令
            let copyOk = false;
            try {
                copyOk = document.execCommand("copy");
                if (copyOk) {
                    Notify({ type: "success", message: "复制成功" });
                } else {
                    Notify({ type: "danger", message: "复制失败" });
                }
            } catch (err) {
                Notify({ type: "danger", message: "复制失败" });
                console.error("复制失败:", err);
            }
            // 移除输入框
            document.body.removeChild(input);
            return copyOk;
        },
        closeIn(item) {
            item.showPopover = false;
            this.$forceUpdate();
        },
        openActivityInfo(activityState) {
            this.activityInfo = true;
            this.activityState = activityState;
        },
        // handleScroll(el) {
        //     let _pos = document.getElementById("apply1").getBoundingClientRect().top;
        // },
        getTimeTamp(time) {
            return new Date(time).getTime();
        },
        getUserInfo(id) {
            getUserInfo(id).then((res) => {
                if (res.code === 0) {
                    this.form.invitationCode = res.data.promotionCode;
                }
            });
        },
        moreFont(item) {
            for (let i = 0; i < this.recordList.length; i++) {
                if (this.recordList[i].id === item.id) {
                    if (this.recordList[i].showPopover === false) {
                        this.recordList[i].showPopover = true;
                    } else {
                        this.recordList[i].showPopover = false;
                    }
                }
            }
            this.$forceUpdate();
        },
        checkDelivery(item) {
            this.checkDeliveryData = item;
            this.addressShow = true;
        },
        // 优惠券/实物
        duihuan(item) {
            this.duihuanData = item;
            if (this.isApp) {
                if (item.activityProductType === 60) {
                    // 实物奖品
                    if (item.isShow) {
                        item.isShow = false;
                    } else {
                        item.isShow = true;
                        this.exchangeId = item.id;
                        if (item.city) {
                            this.addAddress = {
                                phone: item.phone,
                                name: item.name,
                                address: item.address,
                                addressString:
                                    item.province + item.city + item.district,
                                province: item.province,
                                city: item.city,
                                district: item.district,
                            };
                            this.init();
                        }
                        try {
                            // realNameAuth.postMessage("");
                            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                                window.flutter_inappwebview
                                    .callHandler("realNameAuth", {})
                                    .then((result) => {
                                        console.log("Flutter返回:", result);
                                    })
                                    .catch((err) => {
                                        console.error("调用失败:", err);
                                        realNameAuth.postMessage("");
                                    });
                            } else {
                                realNameAuth.postMessage("");
                            }
                        } catch (error) {
                            Notify({
                                type: "warning",
                                message: "请下载最新版App",
                            });
                        }

                        // 直接展开地址表单（realNameAuth回调可能因APP端未实现handler而不触发）
                        this.nextDuihuan(true);
                    }
                } else {
                    // 优惠卷
                    if (item.isCode) {
                        item.isCode = false;
                    } else {
                        try {
                            // realNameAuth.postMessage("");
                            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                                window.flutter_inappwebview
                                    .callHandler("realNameAuth", {})
                                    .then((result) => {
                                        console.log("Flutter返回:", result);
                                    })
                                    .catch((err) => {
                                        console.error("调用失败:", err);
                                        realNameAuth.postMessage("");
                                    });
                            } else {
                                realNameAuth.postMessage("");
                            }
                        } catch (error) {
                            Notify({
                                type: "warning",
                                message: "请下载最新版App",
                            });
                        }

                        // 优惠券直接展开兑换码
                        this.nextDuihuan(true);
                    }
                }
            } else {
                this.infoShow = true;
            }
            this.$forceUpdate();
        },
        nextDuihuan(status) {
            if (status) {
                if (this.duihuanData.activityProductType === 60) {
                    this.duihuanData.isArea = true;
                    this.duihuanData.isAreaList = false;
                    this.exchangeId = this.duihuanData.id;
                    if (this.duihuanData.city) {
                        this.addAddress = {
                            phone: this.duihuanData.phone,
                            name: this.duihuanData.name,
                            address: this.duihuanData.address,
                            addressString:
                                this.duihuanData.province +
                                this.duihuanData.city +
                                this.duihuanData.district,
                            province: this.duihuanData.province,
                            city: this.duihuanData.city,
                            district: this.duihuanData.district,
                        };
                        this.duihuanData.isArea = false;
                        this.duihuanData.isAreaList = true;
                    } else {
                        this.addAddress = {
                            name: "",
                            phone: "",
                            address: "",
                            addressString: "",
                            province: "",
                            city: "",
                            district: "",
                            areaCode: "",
                        };
                        this.duihuanData.isArea = true;
                        this.duihuanData.isAreaList = false;
                    }
                } else {
                    this.duihuanData.isCode = true;
                }
                this.$forceUpdate(); // 强制更新视图
            } else {
                Notify({ type: "warning", message: "未实名注册暂无法兑换" });
            }
        },
        // 现金奖励兑换
        duihuanAmount(item) {
            this.redeemNowList = {};
            if (this.isApp) {
                this.redeemNowList = item;
                try {
                    // realNameAuth.postMessage("");
                    if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                        window.flutter_inappwebview
                            .callHandler("realNameAuth", {})
                            .then((result) => {
                                console.log("Flutter返回:", result);
                            })
                            .catch((err) => {
                                console.error("调用失败:", err);
                                realNameAuth.postMessage("");
                            });
                    } else {
                        realNameAuth.postMessage("");
                    }
                } catch (error) {
                    Notify({ type: "warning", message: "请下载最新版App" });
                }

                // this.goredeemNow(true);
            } else {
                this.infoShow = true;
                // 请在APP内兑换奖励
            }
        },
        goredeemNow(status) {
            if (status) {
                redeemNow({ activitySendId: this.redeemNowList.id }).then(
                    (res) => {
                        if (res.result === true) {
                            // 我的奖品列表;
                            this.getRecordList();
                            this.redeemNowList = {};
                            Notify({ type: "success", message: "已发放" });
                        } else {
                            Notify({
                                type: "danger",
                                message: res.message || "兑换失败",
                            });
                        }
                    }
                );
            } else {
                Notify({ type: "warning", message: "未实名注册暂无法兑换" });
            }
            // this.$forceUpdate(); // 强制更新视图
        },
        // 现金提现
        goWithdrawal() {
            try {
                // this.myPrizeShow = false;
                // gotoWalletPage.postMessage("");
                if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                    window.flutter_inappwebview
                        .callHandler("gotoWalletPage", {})
                        .then((result) => {
                            console.log("Flutter返回:", result);
                        })
                        .catch((err) => {
                            console.error("调用失败:", err);
                            gotoWalletPage.postMessage("");
                        });
                } else {
                    gotoWalletPage.postMessage("");
                }
            } catch (error) {
                Notify({
                    type: "warning",
                    message: "请到“个人中心-钱包管理”提现",
                });
            }
            this.$forceUpdate(); // 强制更新视图
        },
        // 抽奖接口失败/异常：停止转盘并恢复按钮（避免失败后转盘永久旋转、按钮锁死）
        stopWithError(message) {
            // 奖品列表为空时 stop(0) 会使转盘组件死循环，直接提示并恢复
            if (!this.prizes || this.prizes.length === 0) {
                this.noWaitTime = true;
                Notify({ type: "danger", message: message });
                this.getActivityList();
                return;
            }
            let stopIndex = this.prizes.findIndex(
                (item) => item.name === "谢谢参与"
            );
            if (stopIndex === -1) {
                stopIndex = 0;
            }
            try {
                this.$refs.myLucky.stop(stopIndex);
            } catch (e) {
                this.noWaitTime = true;
            }
            // 组件减速停止约需3秒，等停稳后再提示并刷新（避免转盘减速中重建奖品列表）
            setTimeout(() => {
                this.noWaitTime = true;
                Notify({ type: "danger", message: message });
                this.getActivityList();
            }, 3000);
        },
        // gaga兑换码：去兑换（APP内复制兑换码并拉起gaga小程序）
        // CDK兑换码：仅复制（暂不跳小程序）
        copyCdk(item) {
            const code = item.couponCode;
            if (!code) {
                Notify({ type: "warning", message: "兑换码不存在" });
                return;
            }
            this.copyText(code);
        },
        exchangeGaga(item) {
            const code = item.couponCode;
            if (!code) {
                Notify({ type: "warning", message: "兑换码不存在" });
                return;
            }
            if (
                window.flutter_inappwebview &&
                window.flutter_inappwebview.callHandler
            ) {
                const handlerPromise =
                    window.flutter_inappwebview.callHandler(
                        "exchangeGagaSkd",
                        { code: code }
                    );
                // 老版本webview的callHandler可能不返回Promise，直接走兜底
                if (
                    !handlerPromise ||
                    typeof handlerPromise.then !== "function"
                ) {
                    this.gagaFallback(code);
                    return;
                }
                // 未注册handler时flutter_inappwebview可能resolve空值（而非reject/超时），此时也要走兜底
                Promise.race([
                    handlerPromise,
                    new Promise((resolve, reject) => {
                        setTimeout(() => reject(new Error("timeout")), 2000);
                    }),
                ])
                    .then((result) => {
                        if (
                            result === null ||
                            result === undefined ||
                            result === ""
                        ) {
                            this.gagaFallback(code);
                        }
                    })
                    .catch(() => {
                        this.gagaFallback(code);
                    });
            } else {
                this.gagaFallback(code);
            }
        },
        // 兜底：复制兑换码 + 拉起gaga小程序
        // - 安卓 Chrome：用 intent:// 包装 weixin 协议（appid=小程序AppID）拉起微信小程序，失败回跳 noWechat 提示
        // - 微信内/iOS/桌面/其他安卓浏览器：无可靠拉起方式，复制+引导
        // - APP 内由 exchangeGagaSkd 原生 handler 拉起，不走这里
        gagaFallback(code) {
            const copyOk = this.copyText(code);
            const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isChrome = /Chrome/i.test(navigator.userAgent);
            if (!copyOk) {
                Notify({
                    type: "warning",
                    message: "复制失败，请长按兑换码手动复制后前往gaga小程序兑换",
                });
                return;
            }
            if (isAndroid && !isWeChat && isChrome) {
                // 提示后页面即将跳走，提示可能不可见，但兑换码已复制
                Notify({
                    type: "success",
                    message: "兑换码已复制，正在打开微信...",
                });
                // S.browser_fallback_url：微信未安装时 Chrome 回跳本页带 noWechat=1，用于提示用户
                const currentUrl = window.location.href
                    .split("#")[0]
                    .split("?")[0];
                const fallback = encodeURIComponent(`${currentUrl}?noWechat=1`);
                const intent = `intent://dl/business/?appid=wxb468e1976a199f03&path=${encodeURIComponent("pages/user/exchange/index")}#Intent;scheme=weixin;package=com.tencent.mm;S.browser_fallback_url=${fallback};end`;
                window.location.href = intent;
                return;
            }
            Notify({
                type: "success",
                message: isWeChat
                    ? "兑换码已复制，请在微信内搜索\"gaga\"小程序粘贴兑换"
                    : "兑换码已复制，请打开微信搜索\"gaga\"小程序粘贴兑换",
            });
        },
        onSave(content) {
            this.addAddress.addressString =
                content.province + content.city + content.county;
            this.addAddress.province = content.province;
            this.addAddress.city = content.city;
            this.addAddress.district = content.county;
            this.addAddress.name = content.name;
            this.addAddress.phone = content.tel;
            this.addAddress.address = content.addressDetail;
            this.addAddress.type = 2;
            this.addAddress.activitySendRecordId = this.exchangeId;
            this.addAddress.defaultFlag = 0;
            if (this.addAddress.name === "") {
                Notify({
                    type: "warning",
                    message: "请输入联系人",
                });
                return;
            }
            if (this.addAddress.phone === "") {
                Notify({
                    type: "warning",
                    message: "请输入手机号码",
                });
                return;
            }
            if (this.addAddress.province === "") {
                Notify({
                    type: "warning",
                    message: "请选择地区",
                });
                return;
            }
            if (this.addAddress.district === "") {
                Notify({
                    type: "warning",
                    message: "请选择地区",
                });
                return;
            }
            if (this.addAddress.address === "") {
                Notify({
                    type: "warning",
                    message: "请输入详细地址",
                });
                return;
            }
            addAddress(this.addAddress).then((res) => {
                if (res.code === 0) {
                    for (let i = 0; i < this.recordList.length; i++) {
                        if (this.recordList[i].id === this.exchangeId) {
                            this.recordList[i].isArea = false;
                            this.recordList[i].isAreaList = true;
                        }
                    }
                    if (this.duihuanData.city) {
                        Notify({
                            type: "success",
                            message: "修改成功",
                        });
                    } else {
                        Notify({
                            type: "success",
                            message: "添加成功",
                        });
                    }
                    this.getRecordList();
                    this.$forceUpdate();
                }
            });
        },
        sure(item) {
            item.isShow = false;
            this.$forceUpdate();
        },
        makeAddress(id) {},
        activityRules() {
            this.status = 0;
            this.loginShow = true;
        },
        updateAddress(item) {
            this.exchangeId = item.id;
            item.isArea = true;
            item.isAreaList = false;
            if (item.city) {
                this.addAddress = {
                    phone: item.phone,
                    name: item.name,
                    address: item.address,
                    city: item.city,
                    province: item.province,
                    district: item.district,
                    areaCode: item.province + item.city,
                };
                this.init();
            }
            this.$forceUpdate();
        },
        conversion(num) {
            const str = num / 100 + "";
            const intSum = str
                .substring(0, str.indexOf("."))
                .replace(/\B(?=(?:\d{3})+$)/g, ","); //取到整数部
            const dot = str.substring(str.length, str.indexOf(".")); //取到小数部分搜
            const ret = intSum + dot;
            return ret;
        },
        // 日期格式转换(00：00：00)
        dateConversionStart(date) {
            const Y = date.getFullYear();
            const M = (date.getMonth() + 1).toString().padStart(2, 0);
            const D = date.getDate().toString().padStart(2, 0);
            const H = "00";
            const fen = "00";
            const miao = "00";
            return Y + "-" + M + "-" + D + " " + H + ":" + fen + ":" + miao;
        },
        dateConversionEnd(date) {
            const Y = date.getFullYear();
            const M = (date.getMonth() + 1).toString().padStart(2, 0);
            const D = date.getDate().toString().padStart(2, 0);
            const H = "23";
            const fen = "59";
            const miao = "59";
            return Y + "-" + M + "-" + D + " " + H + ":" + fen + ":" + miao;
        },
        getInviteList() {
            // const nowDate = new Date();
            getInviteList({
                // gmtCreateGe: this.dateConversionStart(nowDate),
                // gmtCreateLe: this.dateConversionEnd(nowDate),
                current: 1,
                size: 999,
                registerActivityId: this.activityId,
                orderByFlag: 10,
            }).then((res) => {
                if (res.code === 0) {
                    // 模拟数据
                    // res.data.records = [
                    //     {
                    //         appVersion: "0",
                    //         avatarUrl: "common/default_user_avatar_url.png",
                    //         basisCredit: 100,
                    //         city: "",
                    //         country: "",
                    //         deleteFlag: 0,
                    //         district: "",
                    //         email: "",
                    //         fansCount: 0,
                    //         gmtCreate: "2025-03-21 09:30:37",
                    //         gmtModified: "2025-03-21 09:30:37",
                    //         id: "1902895587835113473",
                    //         identityAuthFlag: { value: 0, desc: "未认证" },
                    //         identityBackUrl: "",
                    //         identityExpireDate: null,
                    //         identityFrontUrl: "",
                    //         identityName: "",
                    //         identityNo: "",
                    //         incrementCredit: 0,
                    //         invitableRightsFrequency: 1,
                    //         invitePhone: "18136925636",
                    //         labels: [],
                    //         nickName: "wowotown0981228",
                    //         phone: "18264579118",
                    //         province: "",
                    //         sex: null,
                    //         signature: "",
                    //         status: { value: 0, desc: "可用" },
                    //         taskApplySuccessCount: 0,
                    //         taskCompleteCount: 0,
                    //         taskCompleteRate: 0,
                    //         testFlag: { value: 0, desc: "否" },
                    //         totalCredit: 100,
                    //     },
                    // ];
                    this.inviteList = res.data.records;
                    this.addCountList = [];
                    for (let j = 0; j < this.inviteList.length; j++) {
                        const phone1 = this.inviteList[j].phone.substring(0, 4);
                        const phone2 = this.inviteList[j].phone.substring(7);
                        this.inviteList[j].phone = phone1 + "****" + phone2;
                    }
                    this.addCountList = this.inviteList;
                    // 切割数组为每组3个元素
                    // if(this.inviteList.length > 1) {
                    //     for (let i = 0; i < this.inviteList.length; i += 1) {
                    //         let group = this.inviteList.slice(i, i + 1);
                    //         while (group.length < 1) {
                    //             group.push({ phone: "" });
                    //         }
                    //         // 只保留最后一组数据
                    //         if (i + 1 >= this.inviteList.length) {
                    //             this.addCountList = group;
                    //         }
                    //     }
                    // } else {
                    //     // 如果总数据量小于等于quoteCount，直接使用全部数据
                    //     this.addCountList = this.inviteList;
                    //     // 补齐空数据到quoteCount个
                    //     if(this.addCountList.length >0){
                    //      while (this.addCountList.length < 1) {
                    //         this.addCountList.push({ phone: "" });
                    //     }
                    //     }else{
                    //         this.addCountList = [];
                    //     }
                    // }
                }
            });
        },
        // 我的奖品
        getRecordList() {
            const types = [10, 30, 50, 60, 70, 100];
            getRecordList({
                activityId: this.activityId,
                activityProductTypes: types.toString(),
                myActivityFlag: 1,
                current: 1,
                size: 999,
            }).then((res) => {
                if (res.code === 0) {
                    this.recordList = res.data.records;
                    for (let i = 0; i < this.recordList.length; i++) {
                        if (this.recordList[i].activityProductType !== 70) {
                            this.recordList[i].showPopover = false;
                            this.recordList[i].productAmount = this.conversion(
                                this.recordList[i].activityProductAmount * 100
                            );
                            this.recordList[i].isShow = false;
                            this.recordList[i].isArea = false;
                            this.recordList[i].isAreaList = false;
                        }
                    }
                }
            });
        },
        closeLoginShow() {
            this.loginShow = false;
            this.getActivityList();
        },
        openLogin(status) {
            this.form.username = "";
            this.form.checkCode = "";
            this.code = "";
            this.status = status;
            if (this.status === 1) {
                this.getCode();
            }
            this.loginShow = true;
        },
        luck() {
            // 大转盘仅APP内可抽：H5环境直接引导下载APP（微信小程序内嵌 H5 已放开抽奖，见 clientType）
            if (!this.isApp && this.clientType !== "wxmini") {
                Notify({
                    type: "warning",
                    message: "抽奖请前往窝窝投APP",
                });
                setTimeout(() => {
                    this.downloadApp();
                }, 600);
                return;
            }
            if (this.prizes && this.prizes.length > 0) {
                for (let i = 0; i < this.prizes.length; i++) {
                    if (i % 2 === 0) {
                        this.prizes[i].background = "#ffffff";
                    } else {
                        this.prizes[i].background = "#FFF8DD";
                    }
                }
            }
            // 重置中奖索引，这样在新的抽奖开始时会清除之前的高亮
            this.winningIndex = -1;
            if (!this.isApp) {
                const token = Cookies.get("mini-token") || "";
                // 小程序内嵌 H5 的 token 是 "_mina" 后缀，需与 H5 自有登录("_h5")一并视为已登录
                const isLoggedToken = token.endsWith("_h5") || token.endsWith("_mina");
                if (!isLoggedToken) {
                    Notify({
                        type: "warning",
                        message: "请登录",
                    });
                    this.openLogin(1);
                    return;
                }
                if (this.activityStatus === 20) {
                    const nowDate = new Date().getTime();
                    this.activityStartTime = this.activityStartTime.replace(
                        /-/g,
                        "/"
                    );
                    this.activityEndTime = this.activityEndTime.replace(
                        /-/g,
                        "/"
                    );
                    const startTime = this.getTimeTamp(this.activityStartTime);
                    const endTime = this.getTimeTamp(this.activityEndTime);
                    if (nowDate < startTime) {
                        this.openActivityInfo(1);
                        return;
                    }
                    if (nowDate > endTime) {
                        this.openActivityInfo(2);
                        return;
                    }
                } else if (this.activityStatus === 30) {
                    this.openActivityInfo(3);
                    return;
                }
                if (this.count === 0 && token !== "" && (token.endsWith("_h5") || token.endsWith("_mina"))) {
                    this.openLogin(2);
                    return;
                }
            } else {
                if (this.activityStatus === 20) {
                    const nowDate = new Date().getTime();
                    this.activityStartTime = this.activityStartTime.replace(
                        /-/g,
                        "/"
                    );
                    this.activityEndTime = this.activityEndTime.replace(
                        /-/g,
                        "/"
                    );
                    const startTime = this.getTimeTamp(this.activityStartTime);
                    const endTime = this.getTimeTamp(this.activityEndTime);
                    if (nowDate < startTime) {
                        this.openActivityInfo(1);
                        return;
                    }
                    if (nowDate > endTime) {
                        this.openActivityInfo(2);
                        return;
                    }
                } else if (this.activityStatus === 30) {
                    this.openActivityInfo(3);
                    return;
                }
                const token = Cookies.get("token") || "";
                if (this.count === 0 && token !== "" && token.includes("app")) {
                    this.openLogin(2);
                    return;
                }
            }
            this.noWaitTime = false;
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play();
            // 模拟调用接口异步抽奖
            setTimeout(() => {
                // 假设后端返回的中奖索引是0
                luckDraw(this.activityId, {
                    id: this.activityId,
                    payType: 10,
                    userAddressId: "",
                }).then((res) => {
                    if (res.code === 0) {
                        // let targetIndex = res.data.sort - 1;
                        if (res.data.type === 40) {
                            // for (let i = 0; i < this.prizes.length; i++) {
                            //         if (this.prizes[i].name === "谢谢参与") {
                            //             targetIndex = i;
                            //             break;
                            //         }
                            //     }
                            setTimeout(() => {
                                this.openLogin(3);
                            }, 2500);
                        } else {
                            setTimeout(() => {
                                this.openLogin(4);
                            }, 2500);
                            this.recordName = res.data.name;
                            this.recordType = res.data.type;
                            if (res.data.type === 70) {
                                this.recordAmount = res.data.amount / 100;
                            } else {
                                this.recordAmount = this.conversion(
                                    res.data.amount * 100
                                );
                            }
                            let images = "";
                            try {
                                images =
                                    JSON.parse(res.data.images).showImages ||
                                    "";
                            } catch (e) {
                                images = "";
                            }
                            this.recordImages = images || this.imgSrc;
                        }
                        this.recordIndex = res.data.sort;
                        // 转盘已按格子数量展开，中奖格需按奖品id定位（同奖品多格时sort不再等于数组下标）
                        const expandedStopIndex = this.prizes.findIndex(
                            (p) => p.id === res.data.id
                        );
                        this.$refs.myLucky.stop(
                            expandedStopIndex === -1
                                ? 0
                                : expandedStopIndex
                        );
                    } else if (res.code === 1001 || res.code === 1000) {
                        // 未登录/登录过期/无有效会话（框架对luckDraw返回1000系统维护）：停止转盘并弹登录，登录后即可用已发放的抽奖次数
                        this.noWaitTime = true;
                        let stopIndex = this.prizes.findIndex(
                            (item) => item.name === "谢谢参与"
                        );
                        if (stopIndex === -1) stopIndex = 0;
                        try {
                            this.$refs.myLucky.stop(stopIndex);
                        } catch (e) {}
                        setTimeout(() => {
                            this.openLogin(2);
                        }, 500);
                    } else {
                        this.stopWithError(
                            res.message || res.msg || "抽奖失败，请稍后重试"
                        );
                    }
                }).catch(() => {
                    this.stopWithError("当前网络不可用，请稍后再试");
                });
                // 调用stop停止旋转并传递中奖索引
                // this.$refs.myLucky.stop(this.recordIndex)
            }, 3000);
        },
        // 点击抽奖按钮会触发star回调
        startCallback() {
            if (this.noWaitTime) {
                if (this.isApp) {
                    const token =
                        Cookies.get("token") ||
                        "6072838ead3247ff8775008c2f938551_app";
                    if (!token.includes("app")) {
                        // eslint-disable-next-line no-undef
                        needLogin.postMessage("needLogin");
                    } else {
                        this.luck();
                    }
                } else {
                    this.luck();
                }
            }
        },
        // 抽奖结束会触发end回调
        endCallback(prize) {
            // 修改当前中奖项的背景色（按id定位，展开后同名奖品多格时避免高亮错格）
            let index = -1;
            if (prize && prize.id) {
                index = this.prizes.findIndex(
                    (item) => item.id === prize.id
                );
            }
            if (index === -1) {
                index = this.prizes.findIndex(
                    (item) => item.name === prize.name
                );
            }
            if (index !== -1) {
                // 修改中奖项的背景色
                this.prizes[index].background = "#FADB62";
                // 保存中奖项索引，用于在弹框关闭后保持高亮
                this.winningIndex = index;
            }
            this.noWaitTime = true;
        },
        drawAgain() {
            this.closeLoginShow();
            setTimeout(() => {
                this.startCallback();
            }, 1000);
        },
        // 查看助力state = 2
        // status=1 点击事件    2是初始化加载;
        myPrize(state) {
            if (this.isApp) {
                const token =
                    Cookies.get("token") ||
                    "6072838ead3247ff8775008c2f938551_app";
                if (!token.includes("app")) {
                    // eslint-disable-next-line no-undef
                    needLogin.postMessage("needLogin");
                } else {
                    this.recordStatus = state;
                    if (state === 1) {
                        this.myPrizeShow = true;
                        this.getRecordList();
                    } else if (state === 2) {
                        // 好友助力列表;
                        this.getInviteList();
                    }
                }
            } else {
                const token = Cookies.get("mini-token") || "";
                // 只有在点击"我的奖品"按钮时(state === 1)才检查登录状态；小程序内嵌 H5 的 "_mina" 也算已登录
                const isLoggedToken2 = token.endsWith("_h5") || token.endsWith("_mina");
                if (state === 1 && !isLoggedToken2) {
                    Notify({
                        type: "warning",
                        message: "请登录",
                    });
                    this.openLogin(1);
                } else if (isLoggedToken2) {
                    // 已登录状态下的处理
                    this.recordStatus = state;
                    if (state === 1) {
                        this.myPrizeShow = true;
                        this.getRecordList();
                    } else if (state === 2) {
                        // 好友助力列表;
                        this.getInviteList();
                    }
                }
            }
        },
        closeMyPrizeShow() {
            this.myPrizeShow = false;
            // this.getActivityList();
        },
        friendsHelp() {
            if (this.isApp) {
                const token =
                    Cookies.get("token") ||
                    "6072838ead3247ff8775008c2f938551_app";
                if (!token.includes("app")) {
                    // eslint-disable-next-line no-undef
                    needLogin.postMessage("needLogin");
                } else {
                    this.sendMessage();
                }
            } else if (this.clientType === "wxmini") {
                // 小程序内嵌 H5 无法跳应用商店，引导用小程序右上角转发
                Notify({
                    type: "warning",
                    message: "请点击右上角转发给好友",
                });
            } else {
                this.downloadApp();
            }
        },
        getActivityList() {
            this.recordIndex = -1;
            getActivityList({
                status: 20,
                type: 20,
                current: 1,
                size: 999999,
            }).then((res) => {
                if (res.code === 0) {
                    this.activityId = res.data.records[0].id;
                    getActivityDetail(this.activityId).then((res) => {
                        if (res.code === 0) {
                            this.helpCount = res.data.todaySurplusCount;
                            this.activityStatus = res.data.status;
                            this.activityStartTime = res.data.startTime;
                            this.activityEndTime = res.data.endTime;
                            this.description = res.data.description;
                            this.description = this.description.replace(
                                /；/g,
                                "；</br>"
                            );
                            this.description = this.description.replace(
                                /;/g,
                                ";</br>"
                            );
                            this.count = res.data.count;
                            this.activityProduct = res.data.activityProduct;
                            this.activityAlldata = res.data;
                            // 按格子数量展开：每个奖品占 gridCount 个格子（转盘平等展示）
                            const expandedPrizes = [];
                            // 接口异常时 activityProduct 可能缺失，防御避免 forEach 崩溃导致白屏
                            const productList = Array.isArray(res.data.activityProduct)
                                ? res.data.activityProduct
                                : [];
                            productList.forEach((item) => {
                                if (item.type === 70) {
                                    item.name = `${item.amount / 100} 元`;
                                }
                                const grid =
                                    Number(item.gridCount) > 0
                                        ? Number(item.gridCount)
                                        : 1;
                                for (let i = 0; i < grid; i++) {
                                    // 显式拷贝，避免依赖对象展开（兼容老WebView内核）
                                    expandedPrizes.push(
                                        Object.assign({}, item)
                                    );
                                }
                            });
                            // 奇数个格子补一个"谢谢参与"保证偶数
                            if (expandedPrizes.length % 2 !== 0) {
                                expandedPrizes.push({
                                    name: "谢谢参与",
                                });
                            }
                            // 先配置好每个格子的文字/图片/背景，再一次性赋值给转盘。
                            // 注意：Vue2 对数组元素新增属性（fonts/imgs）不做响应式，必须在赋值前配好，否则组件收到的是空格子
                            for (let j = 0; j < expandedPrizes.length; j++) {
                                if (expandedPrizes.length < 8) {
                                    expandedPrizes[j].fonts = [
                                        {
                                            text: expandedPrizes[j].name,
                                            top: "8%",
                                            lineClamp: 2,
                                            lengthLimit: "60%",
                                            fontColor: "#F5410E",
                                            fontWeight: "700",
                                            fontFamily: "PingFangSC-Regular",
                                            fontSize: "14px",
                                        },
                                    ];
                                } else {
                                    expandedPrizes[j].fonts = [
                                        {
                                            text: expandedPrizes[j].name,
                                            top: "4%",
                                            lineClamp: 2,
                                            lengthLimit: "60%",
                                            fontColor: "#F5410E",
                                            fontWeight: "700",
                                            fontFamily: "PingFangSC-Regular",
                                            fontSize:
                                                expandedPrizes[j].name.length > 8
                                                    ? "8px"
                                                    : "10px",
                                        },
                                    ];
                                }
                                // 奖品图片：无图（images为空）时只显示文字，避免拼出无效地址
                                const imgSrc =
                                    expandedPrizes[j].type === 70
                                        ? require("@/assets/amountGroup.png")
                                        : expandedPrizes[j].name === "谢谢参与"
                                            ? require("@/assets/thankParticipating.png")
                                            : expandedPrizes[j].images
                                                ? this.picUrl + expandedPrizes[j].images
                                                : "";
                                if (imgSrc) {
                                    expandedPrizes[j].imgs = [
                                        {
                                            src: imgSrc,
                                            width:
                                                expandedPrizes.length < 8
                                                    ? "40px"
                                                    : "30px",
                                            height:
                                                expandedPrizes.length < 8
                                                    ? "40px"
                                                    : "30px",
                                            top:
                                                expandedPrizes.length < 8
                                                    ? "34%"
                                                    : "32%",
                                            borderRadius: "80px",
                                        },
                                    ];
                                }
                                if (j % 2 === 0) {
                                    // FFBF46
                                    expandedPrizes[j].background = "#ffffff";
                                } else {
                                    expandedPrizes[j].background = "#FFF8DD";
                                }
                            }
                            this.prizes = expandedPrizes;
                            if (
                                this.winningIndex !== undefined &&
                                this.winningIndex !== -1 &&
                                this.winningIndex < this.prizes.length
                            ) {
                                this.prizes[this.winningIndex].background =
                                    "#FADB62";
                            }
                        }
                    });
                    this.getRecordList();
                    // 登录判断，如果没登录不执行接口;
                    const token = Cookies.get("mini-token") || "";
                    // const secretKey = Cookies.get("mini-secretKey");
                    if (token) {
                        // if(secretKey){
                        //  if (this.inviteListFetched ===false) {
                        // this.getInviteList();
                        this.myPrize(2);
                        // this.inviteListFetched = true; // 设置标志位为已调用
                        // }
                        // }
                    }
                }
            });
        },
        // 中奖名单 后端返回固定数据
        getWinningList() {
            this.activityRecord = [];
            const typs = [10, 30, 50, 60, 70, 100];
            getActivityRecord({
                activityId: this.activityId,
                activityProductTypes: typs.toString(),
                current: 1,
                size: 10,
                hideFlag: 1, //手机号是否隐藏
            }).then((res) => {
                if (res.code === 0) {
                    this.activityRecord = res.data.records;
                    // start
                    setTimeout(() => {
                        const Danmaku = new easyDanmaku({
                            el: "#container", // 弹幕挂载节点
                            colourful: false, // 彩色弹幕
                            line: 3, // 弹幕行数
                            wrapperStyle: "danmaku-wrapper", // 默认弹幕样式
                            speed: 15, // 弹幕播放速度
                            runtime: 15, // 播放一次的时常
                            loop: true, // 开启循环播放
                            hover: false,
                            coefficient: 1.55,
                        });
                        const datas = this.activityRecord.map((item) => {
                            // 对于类型为70的现金奖励，显示具体金额
                            // if (item.activityProductType === 70) {
                            //     return `恭喜 ${item.userNickPhone} 获得现金 ${item.activityProductAmount / 100} 元`;
                            // }
                            return `恭喜 ${item.userNickPhone} 获得 ${item.activityProductName}`;
                        });
                        Danmaku.batchSend(datas);
                    }, 500);
                    // end
                    if (this.activityRecord.length % 5 === 0) {
                        for (let j = 0; j < this.activityRecord.length; j++) {
                            const phone1 = this.activityRecord[
                                j
                            ].userNickPhone.substring(0, 4);
                            const phone2 =
                                this.activityRecord[j].userNickPhone.substring(
                                    7
                                );
                            this.activityRecord[j].userNickPhone =
                                phone1 + "****" + phone2;
                            if (
                                this.activityRecord[j].activityProductName
                                    .length > 9
                            ) {
                                const str = this.activityRecord[
                                    j
                                ].activityProductName.substring(0, 8);
                                this.activityRecord[j].activityProductName =
                                    str + "...";
                            }
                        }
                    }
                }
            });
        },
        handleRegis() {
            this.form.invitationCode = this.$route.query.invitationCode;
            this.form.registerActivityId = this.activityId;
            if (this.form.username === "") {
                Notify({
                    type: "warning",
                    message: "请输入手机号",
                });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({
                    type: "warning",
                    message: "请输入正确的手机号",
                });
                return false;
            }
            if (this.code === "") {
                Notify({
                    type: "warning",
                    message: "请输入图形验证码",
                });
                return;
            }
            if (this.form.checkCode === "") {
                Notify({
                    type: "warning",
                    message: "请输入短信验证码",
                });
                return;
            }
            fetchLogin(this.form).then((res) => {
                // 登录成功：退出游客模式，使用 H5 登录态（与后端匹配，可正常抽奖）
                sessionStorage.removeItem('guestMode');
                Cookies.set("mini-token", res.token);
                Cookies.set("mini-secretKey", res.secretKey);
                this.userId = res.userId;
                if (this.form.invitationCode) {
                    if (res.isNewUser === true) {
                        Notify({
                            type: "success",
                            message: "助力成功",
                        });
                    } else {
                        Notify({
                            type: "warning",
                            message: "助力失败",
                        });
                    }
                } else {
                    Notify({
                        type: "warning",
                        message: "登录成功",
                    });
                }
                this.closeLoginShow();
                this.getRecordList();
                // this.getInviteList()
            });
        },
        getCode() {
            return fetchCode()
                .then((res) => {
                    return (
                        "data:image/gif;base64," +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ""
                            )
                        )
                    );
                })
                .then((data) => {
                    this.imgUrl = data;
                    return data;
                });
        },
        sendMsg() {
            if (this.form.username === "") {
                Notify({
                    type: "warning",
                    message: "请输入手机号",
                });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({
                    type: "warning",
                    message: "请输入正确的手机号",
                });
                return false;
            }
            if (this.code === "") {
                Notify({
                    type: "warning",
                    message: "请输入图形验证码",
                });
                return;
            }
            if (this.code.length !== 4) {
                Notify({
                    type: "warning",
                    message: "图形验证码长度需为4位",
                });
                return;
            }
            getSmsCaptcha({
                phone: this.form.username,
                businessType: "app_user_login",
                checkCode: this.code,
            })
                .then((res) => {
                    Notify({
                        type: "success",
                        message: "验证码已发送，请查看",
                    });
                    this.state.smsSendBtn = true;
                    const interval = window.setInterval(() => {
                        if (this.state.time-- <= 0) {
                            this.state.time = 60;
                            this.state.smsSendBtn = false;
                            window.clearInterval(interval);
                        }
                    }, 1000);
                })
                .catch(() => {
                    this.getCode();
                });
        },
        sendMessage() {
            this.loginShow = false;
            const title = "窝窝投 & 幸运大转盘";
            const description =
                "无门槛免费抽奖，奖品超多，加入我们开始你的幸运之旅吧！";
            const url = `turntable?id=${this.$route.query.id.substring(
                3
            )}&invitationCode=${this.form.invitationCode}&registerActivityId=${
                this.activityId
            }`;
            // jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("jsBridgeForShare", {info: `${title}|${description}|${url}`})
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
                    });
            } else {
                jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
            }
        },
        downloadApp() {
            this.$router.push("/download");
        },
    },
};
</script>

<style lang="less" scoped>
.turnTable {
    left: 0;
    top: 0;
    background: url(../assets/newTurnBack.png) top left/100% 100% no-repeat;
    width: 100%;
    height: 1150px;
    background-size: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    position: absolute;

    .countClass {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        line-height: 32px;
        text-align: center;
        color: #f86c3c;
        font-size: 14px;
    }

    .notice-swipe {
        position: absolute;
        left: 7%;
        top: 23.5%;
        height: 40vw;
        width: 81vw;
    }

    .myPrize {
        font-weight: bold;
        font-size: 18px;
        margin-left: 30px;
        width: 120px;
        color: rgb(251, 61, 50);
        border: 1px solid #f2a86a;
        background: linear-gradient(rgba(255, 234, 148), rgba(255, 170, 70));
    }

    .button-wrapper {
        position: absolute;
        left: 4%;
        top: 66%;
        display: flex;
        padding: 0 10px;
        justify-content: space-around;
    }

    .descriptionClass {
        font-size: 14px;
        color: #dc1912;
        position: absolute;
        left: 10%;
        top: 76%;
        width: 310px;
        font-family: PingFangSC-Regular;
    }

    .lightClass {
        width: 300px;
        position: absolute;
        left: 10%;
        top: 23%;
    }

    .goClass {
        //z-index: 999;
        position: absolute;
        top: 26%;
        left: 22%;
        width: 220px;
        height: 220px;
    }

    .turn {
        position: absolute;
        margin: 73.2% 12%;
    }
}

.buttonClass {
    background: linear-gradient(
        rgb(255, 188, 66),
        rgb(255, 217, 138),
        rgb(255, 217, 138)
    );
    border: 1px solid rgba(255, 120, 74);
    width: 100px;
    height: 100px;
}

.list-row {
    color: #d8363b;
    line-height: 2.5vh;
}

.longText {
    font-size: 17px;
    font-family: PingFangSC-Medium;
}

.lastButton {
    width: 250px;
    font-size: 18px;
    font-weight: bold;
    color: rgb(251, 61, 50);
    border: 1px solid rgba(255, 151, 89);
    background: linear-gradient(rgba(255, 234, 148), rgba(255, 170, 70));
}

.last {
    position: absolute;
    left: 5%;
    top: 95%;
    display: flex;
    padding: 0 10px;
    justify-content: space-around;
}

.loginBack {
    background: url(../assets/turnLottery.png) top left/100% 100% no-repeat;
    height: 570px;
    width: 340px;
    position: relative;
}

.winningLottery {
    background: url(../assets/bg_not.png) top left/100% 100% no-repeat;
    height: 368px;
    width: 340px;
    position: relative;
    top: 12%;
}

.notWinningLottery {
    background: url(../assets/Group.png) top left/100% 100% no-repeat;
    height: 398px;
    width: 340px;
    position: relative;
    top: 12%;
}

.myAwaryClass {
    background: url(../assets/physicalRewards.png) top left/100% 100% no-repeat;
    height: 425px;
    width: 340px;
    position: relative;
    top: 12%;
    // overflow: hidden;
}

.loginBackground {
    background: url(../assets/bg_loginGo.png) top left/100% 100% no-repeat;
    height: 357px;
    width: 340px;
    position: relative;
    top: 18%;
}

.rulesPop {
    background: url(../assets/ruleExplanation.png) top left/100% 100% no-repeat;
    height: 450px;
    width: 320px;
    position: relative;
    top: 11%;
}

.turnLotteryImg {
    position: relative;
    margin-top: 28%;
    height: 380px;
    width: 340px;
}

.loginButton {
    top: 82%;
    left: 94px;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    padding: 0 40px;
    background: linear-gradient(93deg, #ff3a56 0%, #ff6545 56%, #ff9a30 100%);
}

.yellowClass {
    position: absolute;
    top: 28%;
    left: 22%;
    width: 230px;
}

.appButton {
    position: absolute;
    top: 100%;
    left: 10%;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    padding: 0 20px;
    // border: 1px solid rgba(255, 151, 89);
    background: linear-gradient(133deg, #ff6710 0%, #f73b43 100%);
}

.downloadButton {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 240px;
    font-size: 18px;
    font-weight: bold;
    // color: rgb(251, 61, 50);
    color: #ffffff;
    // border: 1px solid rgba(255, 151, 89);
    background: linear-gradient(133deg, #ff6710 0%, #f73b43 100%);
}

.logoClass {
    position: absolute;
    top: 42%;
    left: 40%;
    width: 80px;
}

.myHelpClass {
    position: absolute;
    top: 155px;
    left: 85px;
    width: 250px;
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    color: #ffffff;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 22px;
}

.myHelpClassTwo {
    position: absolute;
    top: 180px;
    left: 85px;
    width: 250px;
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    color: #ffffff;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 8px;
    font-weight: 10;
}

.myRecordClass {
    position: absolute;
    top: 23%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 250px;
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    color: #ffffff;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 22px;
}

.myRecordClassTwo {
    position: absolute;
    top: 188px;
    left: 85px;
    width: 250px;
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
    color: #ffffff;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 8px;
    font-weight: 10;
}

.form-container {
    .popFontClassOne {
        position: absolute;
        top: 340px;
        left: 80px;
        width: 250px;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        color: #ffffff;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 22px;
    }

    .popFontClassTwo {
        position: absolute;
        top: 370px;
        left: 80px;
        width: 250px;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        color: #ffffff;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 22px;
    }

    .thankFontClassOne {
        position: absolute;
        top: 42%;
        left: 20px;
        right: 0;
        margin: 0 auto;
        text-align: center;
        font-family: PingFangSC-Medium;
    }

    .getFontClassOne {
        position: absolute;
        top: 180px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 250px;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        color: #87151e;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 30px;
    }

    .getFontClassTwo {
        position: absolute;
        top: 230px;
        width: 90%;
        color: #87151e;
        font-size: 24px;
        text-align: center;
        right: 0;
        left: 0;
        margin: 0 auto;
    }

    .van-field {
        // top: 270px;
        // left: 70px;
        // width: 270px;
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        border-radius: 8px;
        margin-bottom: 10px;
        line-height: 40px;

        img {
            height: 40px;
        }
    }
}

.closeImg {
    position: absolute;
    margin: -25% 48%;
    // margin:-40% 46%;
}

.list-wrapper {
    height: calc(100vh - 60vh);
    overflow: hidden;
    overflow-y: auto;
}

.list-wrapper-des {
    height: calc(100vh - 75vh);
}

.list-wrapper-three {
    height: calc(100vh - 76vh);
    overflow-y: auto;
}

#apply1:last-child {
    padding-bottom: 17%;
}

.shop-box {
    position: relative;
    padding: 10px 0;
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .van-col--10 {
        width: 20%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin: 0 auto;

        .van-row {
            width: 96%;
            font-size: 12px;
            text-align: center;
        }
    }

    .img-box {
        display: flex;
        padding: 0 10px;
        justify-content: space-around;
        align-items: center;
    }

    .switch-shop-btn {
        cursor: pointer;
        background: linear-gradient(
            93deg,
            #ff3a56 0%,
            #ff6545 56%,
            #ff9a30 100%
        );
        color: #ffffff;
        font-size: 11px;
        width: 83px;
        height: 27px;
        line-height: 27px;
    }

    .switch-shop-check {
        width: 104px;
        height: 28px;
        color: #ff4352;
        font-size: 11px;
        line-height: 28px;
        text-align: center;
        border: 1px solid #ff4352;
        border-radius: 20px;
    }

    .shop-info-box {
        display: flex;
        width: 70%;
        justify-content: space-around;
        align-items: center;

        p {
            margin: 0;

            &.shop-name {
                color: #87151e;
                font-size: 18px;
                font-weight: bold;
            }

            &:nth-of-type(2),
            &:nth-of-type(3) {
                color: #999999;
                line-height: 20px;
            }
        }

        .useInstructionsClass {
            width: 20px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            word-break: break-all;
        }
    }
}

.shop-boxTwo {
    position: absolute;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    right: 0;
    left: 0;
    margin: 0 auto;

    .img-box {
        display: table-cell;
        vertical-align: middle;
    }

    .shop-info-box {
        display: table-cell;

        p {
            margin-left: 20px;

            &.shop-name {
                color: #ffffff;
                font-family: PingFangSC-Regular;
                font-size: 18px;
                font-weight: bold;
                line-height: 24px;
            }

            &:nth-of-type(2),
            &:nth-of-type(3) {
                color: #999999;
                line-height: 20px;
            }
        }
    }
}

.show {
    height: 100%;
}

.hide {
    display: none;
}

.addClass {
    cursor: pointer;
    background: #feebe1;
    border-radius: 100px 100px 100px 100px;
    border: 1px solid #ff9631;
    font-size: 14px;
    width: 100px;
    height: 30px;
    color: #87151e;
    margin-top: 3vw;
}

/deep/ .van-address-edit__buttons {
    padding: 4vw 1vw 0 1vw;

    .van-button--block {
        cursor: pointer;
        background: #feebe1;
        border-radius: 100px 100px 100px 100px;
        border: 1px solid #ff9631;
        font-size: 14px;
        width: 100px;
        height: 30px;
        color: #87151e;
        margin: 0 auto;
    }
}

/deep/ .van-dialog__content {
    color: #999999;
    margin: 0 5%;
}

/deep/ .van-dialog__header {
    font-size: 18px;
    color: #87151e;
}

/deep/ .van-field__control {
    padding-left: 10px;
}

.sendBtn {
    padding-right: 10px;
}

.itemAvatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.turnTableBtn {
    position: absolute;
    top: 55%;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.turnNumber {
    position: absolute;
    top: 53.5%;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
}

.helpList {
    height: 175px;
    width: 350px;
    background-color: #fff9e9;
    border-radius: 10px;
    position: absolute;
    top: 64%;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.helpListTitle {
    height: 40px;
    background-color: #fef0d4;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: #a54b06;
    font-weight: 500;
    line-height: 40px;
    padding-left: 10px;
    font-size: 15px;
}

.helpListImg {
    height: 41px;
    width: 41px;
    line-height: 44px;
    border-radius: 50%;
    border: 1px solid #ffcdd4;
    font-size: 36px;
    color: #ffcdd4;
    background-color: #ffe5e9;
    text-align: center;
}

.helpListContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 130px;
    width: 100%;
    margin: 0 auto;
}

.helpListDetail {
    height: 210px;
    background-color: #fff9e9;
    border-radius: 10px;
    position: absolute;
    width: 94%;
    top: 79%;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.shareBut {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 10%;
    top: 4.5%;
}

.itemContent {
    height: 150px;
    overflow-y: auto;
    padding: 10px;
}

.itemList {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 20px;
}

.turnPrize {
    font-size: 14px;
    color: #86909c;
    margin-top: 5px;
    margin-bottom: 10px;
}

.turnCloseBtn {
    width: 192px;
    height: 42px;
    background: linear-gradient(93deg, #ff3a56 0%, #ff6545 56%, #ff9a30 100%);
    border-radius: 100px 100px 100px 100px;
    color: #ffffff;
    font-weight: 400;
    font-size: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
}

.activityDate {
    position: absolute;
    top: 13.1%;
    color: #ffffff;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 13px;
}

#container {
    height: 110px;
    margin: 0 auto;
    position: absolute;
    top: 17%;
    color: #ffffff;
    font-size: 14px;
}

/deep/.danmaku-wrapper {
    border-radius: 8px;
    background: rgba(242, 183, 46, 0.3);
    padding: 0 10px;
    line-height: 20px !important;
}

.addressList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
    -webkit-touch-callout: all;
    -webkit-user-select: all;
    -moz-user-select: all;
    -ms-user-select: all;
    user-select: all;
}

.productShipped {
    width: 90px;
    height: 28px;
    background: linear-gradient(270deg, #ff9732 0%, #ff3e54 100%);
    border-radius: 4px;
    text-align: center;
    margin: 10px auto;
    color: #ffffff;
    font-size: 14px;
    line-height: 28px;
}

.copyBtn {
    color: #165dff;
}

.Shipped {
    color: #ffffff;
    font-size: 10px;
    position: absolute;
    left: 17px;
    top: 10px;
    background: #17c2cf;
    border-top-left-radius: 4px;
    padding: 2px 5px;
}

.SystemCoupons {
    position: absolute;
    bottom: 4px;
    align-items: center;
    display: flex;
    justify-content: center;
    left: 22%;
}
.shop-boxx {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
}
</style>
